@if (control) {
  <mat-form-field>
    <mat-label>{{ label() }}</mat-label>
    @if (multiSelect()) {
      <mat-select
        multiple
        [formControl]="control"
        [panelClass]="panelClass()"
        (openedChange)="openedChange.emit($event)"
      >
        <div class="dropdown-list">
          @if ((searchable$ | async) && filterInput()) {
            <mat-form-field class="mb-4">
              <div class="search-grid">
                <mat-icon svgIcon="cp-search" />
                <input matInput [formControl]="searchQuery" (keydown)="$event.stopPropagation()" />
                @if (searchQueryResettable$ | async) {
                  <mat-icon svgIcon="cp-close" (click)="clearSearchQuery()" />
                }
              </div>
            </mat-form-field>
          }
          <div class="dropdown-items">
            @for (
              option of optionsWithVisibilityStatus$ | async;
              track trackByValue($index, option)
            ) {
              @if (option.visible) {
                <mat-option
                  [disabled]="option.disabled"
                  [value]="option.value"
                  class="!py-2 h-auto"
                  >{{ option.label }}</mat-option
                >
              }
            }
          </div>
          <div class="mt-4">
            @if (allSelected$ | async) {
              <button (click)="deselectAll()">Alle abwählen</button>
            } @else {
              <button (click)="selectAll()">Alle auswählen</button>
            }
          </div>
        </div>
      </mat-select>
    } @else {
      <mat-select
        [formControl]="control"
        [panelClass]="panelClass()"
        (openedChange)="openedChange.emit($event)"
      >
        <div class="dropdown-list">
          <ng-content select="[masterSearch]" />
          @if ((searchable$ | async) && filterInput()) {
            <mat-form-field>
              <div class="search-grid">
                <mat-icon svgIcon="cp-search" />
                <input matInput [formControl]="searchQuery" (keydown)="$event.stopPropagation()" />
                @if (searchQueryResettable$ | async) {
                  <mat-icon svgIcon="cp-close" (click)="clearSearchQuery()" />
                }
              </div>
            </mat-form-field>
          }
          <div class="dropdown-items">
            @if (!(required || searchQuery.value)) {
              <mat-option />
            }
            @for (
              option of optionsWithVisibilityStatus$ | async;
              track trackByValue($index, option)
            ) {
              @if (option.visible) {
                <mat-option
                  [disabled]="option.disabled"
                  [value]="option.value"
                  class="!py-2 h-auto"
                  >{{ option.label }}</mat-option
                >
              }
            }
          </div>
        </div>
      </mat-select>
    }
  </mat-form-field>
}
